import module from 'recursoshumanos/module.js'

export class RecursoshumanosReportesRetencionInfonavitService {
  constructor ($http) {
    this.$http = $http
  }

  get (operadora_id, inicio, final, excel) {
    return this.$http.get('/api/recursos_humanos/reportes/retencion/infonavit', {
      params: {operadora_id, inicio: inicio.toYMD(), final: final.toYMD(), excel},
      download: !!excel,
    })
  }
}

module.service('RecursoshumanosReportesRetencionInfonavitService', RecursoshumanosReportesRetencionInfonavitService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/Reportes/RetencionInfonavit.js